import { useQuery } from "@tanstack/react-query";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import { geographiesKeys } from "~/features/geographies";

type GeographiesParams = {
  location?: {
    lat?: number;
    lng?: number;
  };
  geogID?: string;
  externalId?: string;
  include?: "geometry";
};

export function useGeographies({
  location,
  geogID,
  externalId,
  include,
}: GeographiesParams) {
  const { client } = useLocalLogic();

  const fetchGeographies = async () => {
    const params: {
      geogId?: string;
      lat?: number;
      lng?: number;
      externalId?: string;
      include?: "geometry";
    } = {};

    if (geogID) {
      params.geogId = geogID;
    } else {
      params.lat = location?.lat;
      params.lng = location?.lng;
    }

    if (externalId) {
      params.externalId = externalId;
    }

    if (include) {
      params.include = include;
    }

    const response = await client.getGeographies(params);

    return response.geographies;
  };

  return useQuery({
    queryKey: geographiesKeys.list(location!),
    queryFn: fetchGeographies,
    enabled: (!!location?.lat && !!location?.lng) || !!geogID,
  });
}
